import React from "react";
import {
  ReferenceInput,
  SelectInput,
  List,
  Datagrid,
  TextField,
  Filter
} from "react-admin";

const SportSeasonFilter = (props) => {
  return (
    <Filter {...props}>
      <ReferenceInput
        label="Sport"
        source="sportCode"
        reference="sportCodes"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
      <ReferenceInput
        label="Season"
        source="seasonCode"
        reference="availableSeasons"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
    </Filter>
  );
};

const SportSeasonList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<SportSeasonFilter />}>
    <Datagrid rowClick="show">
      <TextField source="sportCode" />
      <TextField source="seasonCode" />
      <TextField source="isCurrent" />
    </Datagrid>
  </List>
);

export default SportSeasonList;
